import {connect} from 'react-redux';
import GroupsMenu, {GroupsMenuProps} from './GroupsMenu';
import ReduxState from '../../types/ReduxState';

const mapStateToProps = (state: ReduxState, ownProps: GroupsMenuContainerProps): GroupsMenuProps => {
   return {
      reviewerGroups: state.reviewerGroups || [],
      addEmails: ownProps.addEmails
   };
};

export default connect(mapStateToProps, null)(GroupsMenu);

interface GroupsMenuContainerProps {
   addEmails(emails: string[]): void;
}
